/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function filter(list, key, term) {
    return [...list].filter(i => i[key].toLocaleLowerCase().includes(term.toLocaleLowerCase()));
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function sortStrings(list, key, sortType) {
    if (sortType === 'ascending') {
        return list.sort((a, b) => a[key].localeCompare(b[key]));
    }
    if (sortType === 'descending') {
        return list.sort((a, b) => a[key].localeCompare(b[key])).reverse();
    }
    return list;
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function swapBetweenLists(targetList, fromList, detail) {
    const itemId = fromList.find(i => i.id === detail.from.id);
    const targetId = targetList.find(i => i.id === detail.target.id);
    const item = fromList.splice(fromList.indexOf(itemId), 1)[0];
    const targetIndex = targetList.indexOf(targetId);
    targetIndex === -1 ? targetList.push(item) : targetList.splice(targetIndex, 0, item);
    return { targetList: [...targetList], fromList: [...fromList] };
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function paginate(arr, size) {
    return [...arr].reduce((acc, val, i) => {
        const idx = Math.floor(i / size);
        const page = acc[idx] || (acc[idx] = []);
        page.push(val);
        return acc;
    }, []);
}
/**
 * @demo
 * @deprecated
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function swapItems(target, src, list) {
    const data = [...list];
    const srcIndex = data.findIndex(i => `${i.id}` === `${src.id}`);
    const srcItem = data.splice(srcIndex, 1)[0];
    const targetIndex = data.findIndex(i => `${i.id}` === `${target.id}`);
    targetIndex === -1 ? data.push(srcItem) : data.splice(targetIndex, 0, srcItem);
    return data;
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function insertBefore(fromIndex, targetIndex, list) {
    const listCopy = [...list];
    const itemRemoved = listCopy.splice(fromIndex, 1);
    const offset = fromIndex + 1 < targetIndex ? -1 : 0;
    listCopy.splice(targetIndex + offset, 0, itemRemoved[0]);
    return listCopy;
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function parseCSV(text) {
    const arr = text
        .trim()
        .split('\n')
        .map(i => i.split(','));
    const csv = {
        columns: arr[0],
        rows: arr.slice(1).map(cells => cells.map(c => c.trim())),
    };
    return csv;
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function exportElementsToCSV(columnElements, rowElements) {
    const columns = Array.from(columnElements).map(c => c.textContent?.trim());
    const rows = Array.from(rowElements).map(r => Array.from(r.children).map(c => `${c.textContent}${c.querySelector('input')?.value}`));
    return `${columns.join(',')}\n${rows.map(cells => `${cells.map(c => c.trim()).join(',')}`).join('\n')}`;
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function toggleRange(rows, indexStart, indexEnd) {
    if (indexStart < indexEnd) {
        rows.slice(indexStart, indexEnd + 1).map(r => (r.selected = rows[indexStart].selected));
    }
    else {
        rows.slice(indexEnd, indexStart + 1).map(r => (r.selected = rows[indexStart].selected));
    }
}
